import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Box, Dialog, useMediaQuery } from '@mui/material';

const SimPopupBox = ({ srcLink, srcTitle, onClose, open }) => {
	const theme = useTheme();

	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true
	});

	const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true
	});

	const isXs = useMediaQuery(theme.breakpoints.up('xs'), {
		defaultMatches: true
	});

	return (
		<Dialog
			onClose={onClose}
			open={open}
			maxWidth={{ xs: '100vw', sm: '100vw', md: '100vw' }}
			display='flex'
			justifyContent='left'
			sx={{
				'& .MuiPaper-root': {
					borderRadius: 0
				}
			}}>
			<Box
				display='flex'
				justifyContent='center'
				bgcolor='black'
				sx={{
					'& .MuiPaper-root': {
						borderRadius: 4
					},

					'&::-webkit-scrollbar': {
						display: 'none'
					}
				}}>
				{isMd ? (
					<Box
						padding={0}
						bgcolor='black'
						display='flex'
						justifyContent='center'
						width='80vw'
						sx={{
							'& .MuiPaper-root': {
								borderRadius: 4
							},

							'&::-webkit-scrollbar': {
								display: 'none'
							}
						}}>
						<Box position='relative' bgcolor='transparent'>
							<iframe
								width='1080'
								height='580'
								src={srcLink}
								title={srcTitle}
								frameborder='0'
								allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
								allowfullscreen>
								{' '}
							</iframe>
						</Box>
					</Box>
				) : isSm ? (
					<Box
						padding={0}
						bgcolor='transparent'
						display='flex'
						justifyContent='center'
						width='95vw'
						sx={{
							'& .MuiPaper-root': {
								borderRadius: 4
							},

							'&::-webkit-scrollbar': {
								display: 'none'
							}
						}}>
						<Box position='relative' bgcolor='transparent'>
							<iframe
								width='560'
								height='315'
								src={srcLink}
								title={srcTitle}
								frameborder='0'
								allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
								allowfullscreen></iframe>
						</Box>
					</Box>
				) : isXs ? (
					<Box
						padding={0}
						bgcolor='transparent'
						display='flex'
						justifyContent='center'
						width='95vw'
						sx={{
							'& .MuiPaper-root': {
								borderRadius: 4
							},

							'&::-webkit-scrollbar': {
								display: 'none'
							}
						}}>
						<Box position='relative' bgcolor='transparent'>
							<iframe
								bgcolor='transparent'
								width='320'
								height='180'
								src={srcLink}
								title={srcTitle}
								frameborder='0'
								allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
								allowfullscreen></iframe>
						</Box>
					</Box>
				) : null}
			</Box>
		</Dialog>
	);
};

SimPopupBox.propTypes = {
	onClose: PropTypes.func.isRequired,
	open: PropTypes.bool.isRequired
};

export default SimPopupBox;
